export const introductionData = [{
    "title": "Introduction",
    "content": `Hello there! I am Penn Han, a 3rd Year Computer Science Undergraduate studying at 
    the School of Computing, National University of Singapore. I am a recipent of the Smart Nation Scholarship, a Civil Service Scholarship awarded by
    the Smart Nation Digital Government Office and I am tagged to Infocomm Media Development Authorities. I am passionate in the field of Artificial Intelligence and Computer
    Security and would love to be involved in tech projects that strives to benefit a large community. My dream is to lead projects that will positively change the lives of people in my
    community through implementation of solutions that will build on the strengths of technology`,
    "link": ""
}]